import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { logout } from 'external/firebase/controllers/auth';
import useAuth from 'hooks/useAuth';
import { Register } from 'pages';
import { PATH_AUTH, PATH_DASHBOARD } from 'routes/paths';

const GuestGuard: React.FunctionComponent = ({ children }) => {
    const { user, profile } = useAuth();
    const { search, pathname } = useLocation();
    const searchParams = new URLSearchParams(search);

    const code = searchParams.get('code') || '';

    if (pathname === PATH_AUTH.register && code) {
        return <Register />;
    }

    if (user && user.emailVerified && profile?.role) {
        return <Navigate to={PATH_DASHBOARD.root} />;
    }

    return <>{children}</>;
};

export default GuestGuard;
